import { useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { field, card } from "@/components/admin/SettingsPanel";

const FIELDS = [
  ["phone", "Phone number", "+692 …"],
  ["freq", "Radio frequency", "FM 00.0"],
  ["address_en", "Studio address (English)", "Street, Majuro, Marshall Islands"],
  ["address_mh", "Studio address (Marshallese)", "Street, Ṃajro, Aelōn̄ in Ṃajeḷ"],
];

export const ContactDetails = () => {
  const { settings, setSettings } = useSite();
  const text = settings?.text || {};
  const [f, setF] = useState({
    phone: text.en?.["contact.phoneValue"] || "",
    freq: text.en?.["contact.freqValue"] || "",
    address_en: text.en?.["contact.addressValue"] || "",
    address_mh: text.mh?.["contact.addressValue"] || "",
  });
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    const lang = (l, address) => ({ ...(text[l] || {}), "contact.phoneValue": f.phone, "contact.freqValue": f.freq, "contact.addressValue": address });
    try {
      const { data } = await api.put("/settings/text", { en: lang("en", f.address_en), mh: lang("mh", f.address_mh) });
      if (data?.pending) {
        toast("Sent for approval — it will appear once a Super Admin approves it");
      } else {
        setSettings((p) => ({ ...p, ...data }));
        toast.success("Contact details saved — live on the site");
      }
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="contact-details-card" className={`${card} lg:col-span-2`}>
      <h3 className="font-display text-2xl text-[#F4EEE2]">Contact details</h3>
      <p className="mt-1 text-sm text-[#B7BFCC]">Shown on the Contact page in both languages. Leave a box empty to show the placeholder.</p>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        {FIELDS.map(([k, label, ph]) => (
          <label key={k} className="block">
            <span className="font-ui text-xs uppercase tracking-wider text-[#B7BFCC]">{label}</span>
            <input data-testid={`contact-${k}-input`} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} placeholder={ph} className={`${field} mt-1.5`} />
          </label>
        ))}
      </div>
      <button data-testid="contact-details-save-btn" onClick={save} disabled={busy} className="mt-5 flex items-center gap-2 rounded-full bg-[#D4AF37] px-6 py-3 font-ui text-sm font-semibold text-[#0B111E] disabled:opacity-60">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Save contact details
      </button>
    </div>
  );
};
